import Icon from '../components/Icon.vue'

Icon.register({
  'caret-right': {
    width: 192,
    height: 512,
    paths: [
      {
        d: 'M0 384.7v-257.3c0-17.8 21.5-26.7 34.1-14.1l128.7 128.7c7.8 7.8 7.8 20.5 0 28.3l-128.7 128.7c-12.6 12.6-34.1 3.7-34.1-14.1z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/caret-right.js
// module id = 1152
// module chunks = 0